import React from "react";

const TapeWidget = () => {
  return (
    <div>
      {/* <div class="tradingview-widget-container">
        <div class="tradingview-widget-container__widget"></div>
      </div>
      <script
        type="text/javascript"
        src="https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js"
        async
      >
        {{
          symbols: [
            {
              proName: "FOREXCOM:SPXUSD",
              title: "S&P 500",
            },
            {
              proName: "FOREXCOM:NSXUSD",
              title: "US 100",
            },
            {
              proName: "FX_IDC:EURUSD",
              title: "EUR to USD",
            },
            {
              proName: "BITSTAMP:BTCUSD",
              title: "Bitcoin",
            },
            {
              proName: "BITSTAMP:ETHUSD",
              title: "Ethereum",
            },
          ],
          showSymbolLogo: true,
          colorTheme: "dark",
          isTransparent: false,
          displayMode: "adaptive",
          locale: "en",
        }}
      </script> */}
    </div>
  );
};

export default TapeWidget;
